/**
 * Does this class sell a monthly membership at all (#4968)?
 *
 * `classes.monthly_rate` is never blank, so a class that does not sell monthly —
 * an open gym (pay per visit), one with monthly turned off, or a Session Program
 * (priced by its total, #5829) — still holds a number, and a reader that trusts
 * the price prints a monthly price nobody sells. One predicate for every surface:
 * the catalog, the class page and the crawler must agree with each other.
 */
export function classSellsMonthly(row: {
  is_open_gym?: boolean | null;
  is_session_based?: boolean | null;
  monthly_membership_enabled?: boolean | null;
}): boolean {
  return row.is_open_gym !== true && row.is_session_based !== true && row.monthly_membership_enabled !== false;
}
